import { render } from "./InlineUsage.vue?vue&type=template&id=3cb56de4"
import script from "./InlineUsage.vue?vue&type=script&lang=ts"
export * from "./InlineUsage.vue?vue&type=script&lang=ts"
script.render = render

export default script